import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import CancelIcon from "@mui/icons-material/Cancel";

const approvedIcon = (
  <CheckCircleIcon sx={{ ml: 0.5, mr: 2 }} color="success" />
);
const pendingIcon = <PendingIcon sx={{ ml: 0.5, mr: 2 }} color="action" />;
const rejectedIcon = <CancelIcon sx={{ ml: 0.5, mr: 2 }} color="error" />;

export function StatusIconsSwitch({ status }) {
  const iconSwitch = (status) => {
    switch (status) {
      case "pending":
        return pendingIcon;
      case "Accepted":
        return approvedIcon;
      case "Rejected":
        return rejectedIcon;
      case true:
        return approvedIcon;
      case false:
        return rejectedIcon;
      default:
    }
  };

  return iconSwitch(status);
}
